module.exports = __webpack_public_path__ + "static/media/digital-marketing-triangle.8bffc908.svg";